<div class="overzicht-wrapper">
    <ngx-spinner bdColor="rgba(0,0,0,0.8)" size="medium" color="#bdd6e5" type="ball-atom" [fullScreen]="true">
        <p style="color: white"> uw bestelling wordt verzonden... </p>
    </ngx-spinner>

    <div class="container px-4 py-5 my-5 text-center bg-white rounded-4">
        <h1 class="display-5 fw-bold text-body-emphasis">Dorpelbestellen.nl</h1>
        <h4>Orderoverzicht</h4>
    </div>

    <div class="container-fluid">
        <div class="container bg-white px-4 py-4 my-4 rounded-4">
            <div class="col-md-8 page-title">
                <h4>Orderbevestiging</h4>
            </div>
            <br>
            <div class="row d-flex">
                <div class="col-md-8">
                    <div *ngIf="logoUrl" class="logo-holder">
                        <img id="logo" class="rounded img-fluid" width="75" height="30" [src]="logoUrl">
                    </div>
                    <table>
                        <tr>
                            <td>
                                <b>Klant:</b>
                            </td>
                            <td>
                                {{model.opdrachtgever}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>Dealer:</b>
                            </td>
                            <td>
                                {{model.dealerCode}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>Contactpersoon:</b>
                            </td>
                            <td>
                                {{model.contactpersoon}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>Telefoonnummer:</b>
                            </td>
                            <td>
                                {{model.telefoonnummer}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>E-mailadres:</b>
                            </td>
                            <td>
                                {{model.emailadres}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>uw referentie:</b>
                            </td>
                            <td>
                                {{model.uwReferentie}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>Gewenste afleverdatum:</b>
                            </td>
                            <td>
                                {{model.afleverdatum}}
                            </td>
                        </tr>
                        <tr *ngIf="model.opmerkingen">
                            <td colspan="2">
                                <b>Opmerkingen:</b>
                            </td>
                        </tr>
                        <tr *ngIf="model.opmerkingen">
                            <td colspan="2">
                                {{model.opmerkingen}}
                            </td>
                        </tr>
                        <tr *ngIf="model.files.length > 0">
                            <td colspan="2">
                                <b>bijlage:</b>
                            </td>
                        </tr>
                        <tr *ngFor="let file of model.files">
                            <td colspan="2">
                                {{file?.name || 'er is geen bijlage geselecteerd'}}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <div class="row my-2 justify-content-center" *ngFor="let dorpel of model.dorpels; let last = last">
            <div class="container bg-white px-4 py-4 my-4 rounded-4">
                <h5>{{dorpel.dorpelCode}} - {{dorpel.merk}} - {{dorpel.zaagmaat}}MM ({{dorpel.aantal}} stuks)</h5>

                <div class="row my-2">
                    <!-- <div class="col overzicht-data" *ngIf="dorpel.omschrijving">
                        <label for="maata">Dorpeltype:</label><br> {{dorpel.omschrijving}}
                    </div> -->
                    <div class="col overzicht-data" *ngIf="dorpel.schema">
                        <label for="maata">Dorpel Schema:</label><br> {{dorpel.schema}}
                    </div>
                    <div class="col overzicht-data" *ngIf="dorpel.aantal">
                        <label for="maata">Aantal:</label><br> {{dorpel.aantal}}
                    </div>
                    <div class="col overzicht-data" *ngIf="dorpel.merk">
                        <label for="referentie">Merk:</label><br> {{dorpel.merk}}
                    </div>
                    <div class="col overzicht-data" *ngIf="dorpel.zaagmaat">
                        <label for="Zaagmaat">Zaagmaat:</label><br> {{dorpel.zaagmaat}} MM
                    </div>
                    <div class="col overzicht-data" *ngIf="dorpel.neuten.length">
                        <label for="Zaagmaat">Aantal Neuten:</label><br> {{dorpel.neuten.length}}
                    </div>
                    <div class="col overzicht-data" *ngIf="dorpel.sluitpotten.length">
                        <label for="Zaagmaat">Aantal Sluitpotten:</label><br> {{dorpel.sluitpotten.length}}
                    </div>
                </div>

                <div class="row my-2 justify-content-center" *ngIf="dorpel.drawing">
                    <div class="col-md-12 justify-content-center">
                        <img class="dorpel-drawing" [src]="dorpel.drawing" alt="drawing">
                    </div>
                </div>


                <div class="row my-2 justify-content-center">
                    <div class="col overzicht-data" *ngIf="dorpel.firstMaatA">
                        <label for="firstMaatA">Vak 2:</label><br> {{dorpel.firstMaatA}} MM
                    </div>
                    <div class="col overzicht-data" *ngIf="dorpel.deurmaatA">
                        <label for="deurmaatA">Deurmaat:</label><br> {{dorpel.deurmaatA}} MM
                    </div>
                    <div class="col overzicht-data" *ngIf="dorpel.maatB">
                        <label for="maatB">Vak 2:</label><br> {{dorpel.maatB}} MM
                    </div>
                    <div class="col overzicht-data" *ngIf="dorpel.deurmaatB">
                        <label for="deurmaatB">Deurmaat:</label><br> {{dorpel.deurmaatB}} MM
                    </div>
                    <div class="col overzicht-data" *ngIf="dorpel.maatC">
                        <label for="maatC">Vak 3:</label><br> {{dorpel.maatC}} MM
                    </div>
                    <div class="col overzicht-data" *ngIf="dorpel.deurmaatC">
                        <label for="deurmaatC">Deurmaat:</label><br> {{dorpel.deurmaatC}} MM
                    </div>
                </div>
                <br />
                <div class="row my-2 justify-content-center">
                    <ng-container *ngFor="let neut of dorpel.neuten; let i = index">
                        <div class="col overzicht-data justify-content-center" *ngIf="i == 0 && dorpel.maatA">
                            <label for="maata">Vak 1:</label><br> {{dorpel.maatA}} MM
                        </div>

                        <div class="col overzicht-data justify-content-center">
                            <label>Neut:</label><br />
                            <div *ngIf="neut.neutDescription">
                                <span>{{neut.neutDescription}}</span>
                            </div>
                            <div *ngIf="neut.neutCode">
                                <span>{{neut.neutCode}}</span>
                            </div>
                            <div *ngIf="neut.linksVoorsponning || neut.rechtsVoorsponning">
                                <br />
                                <label>Voorsponning:</label><br />
                                <div *ngIf="neut.linksVoorsponning">
                                    <span *ngIf="neut.linksVoorsponning">Links -
                                        {{neut.linksVoorsponning.width}}x{{neut.linksVoorsponning.height ||
                                        neut.linksVoorsponning.width}} MM</span><br />
                                </div>
                                <div *ngIf="neut.rechtsVoorsponning">
                                    <span *ngIf="neut.rechtsVoorsponning">Rechts -
                                        {{neut.rechtsVoorsponning.width}}x{{neut.rechtsVoorsponning.height ||
                                        neut.rechtsVoorsponning.width}} MM</span>
                                </div>
                            </div>
                            <div *ngIf="neut.customWidth">
                                <br />
                                <label>Neutbreedte:</label><br />
                                <span>{{neut.customWidth}} MM</span>
                            </div>
                        </div>

                        <div class="col overzicht-data justify-content-center"
                            *ngIf="i == dorpel.neuten.length-1 && dorpel.maatZ">
                            <label for="maatZ">{{getMaatZLabel(i+2, dorpel.dorpelCode, dorpel.schema)}}:</label>
                            <br> {{dorpel.maatZ}} MM
                        </div>

                        <div class="col overzicht-data justify-content-center" *ngIf="i < dorpel.neuten.length-1">
                            <div *ngIf="!dorpel.schema">
                                <div *ngIf="neut.daagmaat">
                                    <br />
                                    <label for="daagmaata1">Vak {{(i+2)}} Dagmaat:</label><br>
                                    <span>{{neut.daagmaat}} MM</span><br>
                                </div>
                                <div *ngIf="neut.sponningsoort">
                                    <br />
                                    <label for="sponningsoort">Uitvoering:</label><br>
                                    <span>{{neut.sponningsoort}}</span><br>
                                </div>
                                <div *ngIf="neut.sponningmaat">
                                    <br />
                                    <label>Sponningdiepte:</label><br />
                                    <span>{{neut.sponningmaat}} MM</span><br />
                                </div>
                                <div *ngIf="neut.glaslat">
                                    <br />
                                    <label for="glaslat">Glaslat:</label><br>
                                    <span>{{neut.glaslat}}</span>
                                </div>
                                <div *ngIf="neut.beglazingsprofiel">
                                    <br />
                                    <label for="beglazingsprofiel">Beglazingsprofiel:</label><br>
                                    <span>{{neut.beglazingsprofiel}}</span>
                                </div>
                                <div *ngIf="neut.aanslagprofiel">
                                    <br />
                                    <label for="aanslagprofiel">Aanslagprofiel:</label><br>
                                    <span>{{neut.aanslagprofiel}}</span>
                                </div>
                                <div *ngIf="neut.damverbreeding">
                                    <br />
                                    <label for="damverbreeding">Damverbreding:</label><br>
                                    <span>{{neut.damverbreeding}}</span>
                                </div>
                                <div>
                                    <br />
                                    <label for="gemonteerd">Gemonteerd:</label><br>
                                    <span *ngIf="neut.gemonteerd">Ja</span>
                                    <span *ngIf="!neut.gemonteerd">Nee</span>
                                </div>
                                <div>
                                    <br />
                                    <label for="dubbelAanslagprofiel">Dubbel aanslagprofiel:</label><br>
                                    <span *ngIf="neut.dubbelAanslagprofiel">Ja</span>
                                    <span *ngIf="!neut.dubbelAanslagprofiel">Nee</span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <br>
                <ng-container *ngFor="let sp of dorpel.sluitpotten; let i = index">
                    <div class="row my-2 justify-content-center">
                        <div class="col overzicht-data justify-content-center">
                            <label>Sluipot {{(i+1)}}</label><br>
                            {{sp.omschrijving}}{{getSluitpotDimensions(sp)}}
                        </div>
                    </div>
                </ng-container>
                <div *ngIf="dorpel.railType" class="row my-2 justify-content-center">
                    <div class="col overzicht-data justify-content-center">
                        <br><br>
                        <label>Rail:</label><br> {{dorpel.railType}}
                    </div>
                </div>
                <div *ngIf="getConcatenatedBewerkingen(dorpel)" class="row my-2 justify-content-center">
                    <div class="col overzicht-data justify-content-center">
                        <br><br>
                        <label for="Renovatiesponning">Bewerkingen / opties:</label><br>
                        {{getConcatenatedBewerkingen(dorpel)}}
                    </div>
                </div>
                <div *ngIf="dorpel.opmerking" class="row my-2 justify-content-center">
                    <div class="col overzicht-data justify-content-center">
                        <br><br>
                        <label for="Opmerking">Opmerking:</label><br> {{dorpel.opmerking}}
                    </div>
                </div>
                <br>
                <br>
                <div class="row my-4 justify-content-center" *ngIf="last">
                    <div class="col-sm-4 justify-content-center buttons-wrapper btn-group" role="group">
                        <button type="button"
                            class="action-button btn btn-secondary btn-lg px-4 gap-3 border-1 rounded-10"
                            (click)="onGoBackButtonClicked()"><b>Bestelling wijzigen</b></button>
                        <button type="button"
                            class="action-button btn btn-secondary btn-lg px-4 gap-3 border-1 rounded-10"
                            (click)="onDorpelConfirmButtonClicked()"><b>Bestelling plaatsen</b></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>